const formatDate = (inputDate) => {
  const options = { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" };
  const date = new Date(inputDate);

  return `${date.toLocaleDateString("id-ID", options)} WIB`;
}

export default formatDate;